import { useCallback, useState } from 'react';
import { MARKDOWN_TYPING_SPEED } from '../helpers/progressgpt.constants';

const useProgressGPTMarkdownTyping = () => {
    const [typingId, setTypingId] = useState<string>(null);

    const setTyping = useCallback((typingId: string, options: { length: number }) => {
        setTypingId(typingId);

        setTimeout(() => {
            setTypingId(null);
        }, options.length * MARKDOWN_TYPING_SPEED);
    }, []);

    return [typingId, setTyping] as const;
};

export default useProgressGPTMarkdownTyping;
